/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["accordion[_ngcontent-%COMP%]{overflow-y:scroll;max-height:80vh}.btn-search[_ngcontent-%COMP%]{color:#fff;background-color:#337ab7}\n/*# sourceMappingURL=geoguide.component.css.map*/"];
export { styles as styles };
